// extracted by mini-css-extract-plugin
module.exports = {"size_guide":"SizeDropdown_size_guide__4AvAq","disabled":"SizeDropdown_disabled__BV_pd"};